import {serviceResolver} from "@infonova/framework/lib/service/configuration/serviceResolver";
import {serviceRegistry} from "@infonova/framework/lib/service/configuration/serviceRegistry";
import { serviceIdentifier } from "@infonova/framework/lib/service/serviceIdentifier";
import {IntegrationImpl} from "../integration/IntegrationImpl";
// import {StartedInfonova} from "../../../infonova/infonova";
import {RouterMessage} from "@infonova/framework/lib/router/types/RouterMessage";
import {MessageConsumer} from "@infonova/framework/lib/message/types/MessageConsumer";
import {Logger} from "@infonova/framework/lib/logger/Logger";
import {LoggerFactory} from "@infonova/framework/lib/logger/LoggerFactory";

const LOGGER:Logger =LoggerFactory.getInstance('IntegrationConfiguration');
/**
 * Create router message consumer.
 * @param infonova
 */
function createRouterMessageConsumer(infonova: any): MessageConsumer<RouterMessage> {
    return (message) => {
        infonova.getRouterService().goto(message.payload);
        return true;
    };
}

export class IntegrationConfiguration {

    private static waitForInfonova(): Promise<void> {
        return new Promise<void>(resolve => {
            const timeHandler = () => {
                if (window.$infonova) {
                    resolve();
                    return;
                }
                setTimeout(timeHandler, 10);
            };
            timeHandler();
        });
    }

    private static setUpIntegration(applicationStartup: () => void, componentStartup: () => void) {
        // Initialize integration object
        const integration = new IntegrationImpl(
            serviceResolver()
            , serviceRegistry()
            , applicationStartup
            , componentStartup);

        // window.$infonova.start();


        window.$infonova.onStart((infonova) => {
            // .registerApiBasePath('https://integration.dublincoe.lab.infonova.com/credentialmanager-app/r6-api/SB_BEYONDTS_EXPDEV01')
            // .registerTenant('SB_BEYONDTS_EXPDEV01')
            // .registerAuthorizationProvider(new AuthorizationProviderImpl())
            // .registerLocaleService(new LocaleServiceImpl())
            // .registerRouterMessageConsumer(new RouterMessageConsumer().consume)
            // .registerNotificationMessageConsumer(new NotificationMessageConsumer().consume)

            return integration
                .registerApiBasePath(infonova.getApiBasePath())
                .registerAuthorizationProvider(infonova.getAuthorizationProvider())
                .registerLocaleService(infonova.getLocaleService())
                .registerTenant(infonova.getTenant())
                .registerTemplateRepository(infonova.getTemplateRepository())
                .registerRouterMessageConsumer(createRouterMessageConsumer(infonova))
                .start().then((started) => {
                    LOGGER.debug('%c[exp-framework-infonova-component-templates]%c Integration initialized', 'color:blue; background-color:black', '', started);
                    const evt = new CustomEvent("infonova-app-started", {detail: "" + infonova.getApiBasePath()});
                    window.dispatchEvent(evt);
                });
        });
    }

    static configure(applicationStartup: () => void, componentStartup: () => void) {
        this.waitForInfonova()
            .then(() => this.setUpIntegration(applicationStartup, componentStartup))
    }

}